// extracted by mini-css-extract-plugin
export default {"chartPlaceHolder":"Parking_chartPlaceHolder__OdUm8","chartLegend":"Parking_chartLegend__JNxRj"};